<template>
  <div>
    <h3 class="title title_mark">经济效益</h3>
    <a-alert
      v-if="description !== false"
      message="注意!"
      :description="description"
      type="warning"
      show-icon
      style="margin: 0px 32px 0px 15px"
    />
    <a-form :form="form" :label-col="{ span: 10 }" :wrapper-col="{ span: 12 }">
      <a-form-item label="预估经济效益">
        <!-- :disabled="!isEdit" -->
        <a-radio-group
          @change="(e) => changeRadio(e.target.value, 'participate')"
          v-decorator="[
            'participate',
            { rules: [{ required: true, message: '请选择' }] },
          ]"
          size="small"
        >
          <a-radio-button :value="true"> 是 </a-radio-button>
          <a-radio-button :value="false"> 否 </a-radio-button>
        </a-radio-group>
        <p style="line-height: 16px;  color:#999;font-size: 13px">
          预估经济效益仅在饲喂程序完整（从苗猪到出栏）时计算准确
        </p>
      </a-form-item>
      <a-form-item label="经济效益计算模式" v-if="participate">
        <a-select
          placeholder="请选择"
          @change="(e) => changeEcoModel(e, 'ecoModel')"
          v-decorator="[
            'ecoModel',
            { rules: [{ required: true, message: '请选择经济效益计算模式' }] },
          ]"
        >
          <a-select-option
            v-for="el in dataDictionary.EcoModel"
            :key="el.dictKey"
            :value="el.dictKey"
          >
            <a-tooltip>
              <template slot="title">
                {{ el.dictValue }}
              </template>
              {{ el.dictValue }}
            </a-tooltip>
          </a-select-option>
        </a-select>
      </a-form-item>
      <a-form-item
        label="胴体市场价格"
        v-if="participate && ecoModel === 'IOTCC'"
      >
        <a-input-number
          class="inputClass"
          placeholder="请输入"
          v-decorator="[
            'gfCarcassPrice',
            { rules: [{ required: true, message: '请输入胴体市场价格' }] },
          ]"
          :min="0"
          :precision="2"
          @blur="(e) => checkVal(e, 'gfCarcassPrice')"
        />
        <span class="unitClass">元/kg</span>
      </a-form-item>
      <a-form-item
        label="活猪市场价格"
        v-if="participate && ecoModel === 'IOTCL'"
      >
        <a-input-number
          class="inputClass"
          placeholder="请输入"
          v-decorator="[
            'gfPigPrice',
            { rules: [{ required: true, message: '请输入活猪市场价格' }] },
          ]"
          :min="0"
          :precision="2"
          @blur="(e) => checkVal(e, 'gfPigPrice')"
        />
        <span class="unitClass">元/kg</span>
      </a-form-item>

      <a-form-item label="屠宰率" v-if="participate && ecoModel === 'IOTCC'">
        <a-input-number
          class="inputClass"
          placeholder="请输入"
          v-decorator="[
            'slaughterrate',
            { rules: [{ required: true, message: '请输入屠宰率' }] },
          ]"
          :min="0"
          :max="100"
          :precision="2"
          @blur="(e) => checkVal(e, 'slaughterrate')"
        />
        <span class="unitClass">%</span>
      </a-form-item>

      <template v-if="participate">
        <a-form-item label="饲料价格">
          <a-radio-group
            v-decorator="[
              'feedPriceModel',
              { rules: [{ required: true, message: '请选择' }] },
            ]"
            @change="(e) => changeRadio(e.target.value, 'feedPriceModel')"
          >
            <a-radio value="FORMULA_OPTIMIZATION_PRICE">配方优化价格</a-radio>
            <a-radio value="FEED_END_USER_PRICE">饲料终端价格</a-radio>
          </a-radio-group>
          <p
            style="line-height: 16px;  color:#999;font-size: 13px"
            v-if="feedPriceModel == 'FORMULA_OPTIMIZATION_PRICE'"
          >
            配方优化价格自动从饲喂程序使用的配方中读取，可能偏离实际市场价格
          </p>
          <p style="line-height: 16px;  color:#999;font-size: 13px" v-else>
            饲料终端价格为实际市场价格,计算的饲料成本和生产成本更有参考性
          </p>
        </a-form-item>

        <a-form-item
          label="配方优化价格"
          v-if="feedPriceModel == 'FORMULA_OPTIMIZATION_PRICE'"
        >
          <span style="font-size: 13px">NHF配方中读取</span>
        </a-form-item>

        <div
          v-if="feedPriceModel == 'FEED_END_USER_PRICE'"
          style="width: 74%; margin-left: 18%"
        >
          <p style="line-height: 16px;  color:#999;font-size: 13px">
            设置饲喂程序各体重阶段饲料终端价格
          </p>
          <a-table
            :data-source="feedPriceDays"
            :columns="columns"
            :pagination="false"
            style="margin: 6px 0 10px"
          >
            <template slot="field" slot-scope="text, record">
              <span>{{ record.initialBw }}-{{ record.finalBw }}kg</span>
            </template>
            <template slot="price" slot-scope="text, record">
              <a-input-number
                v-model="record.price"
                @blur="() => handleChage(record, 'price')"
                :min="0"
                :precision="2"
              />
            </template>
          </a-table>
        </div>
      </template>

      <a-form-item label="苗猪成本" v-if="participate">
        <a-input-number
          class="inputClass"
          placeholder="请输入"
          v-decorator="[
            'pigCost',
            { rules: [{ required: true, message: '请输入苗猪成本' }] },
          ]"
          :min="0"
          :precision="2"
        />
        <span class="unitClass">元/头</span>
      </a-form-item>

      <template v-if="participate">
        <a-form-item label="栏位成本模式">
          <a-radio-group
            v-decorator="[
              'pencostModel',
              { rules: [{ required: true, message: '请选择栏位成本模式' }] },
            ]"
            @change="(e) => changeRadio(e.target.value, 'pencostModel')"
          >
            <a-radio value="PencostModelTotal">总栏位成本</a-radio>
            <a-radio value="PencostModelDay">日栏位成本</a-radio>
          </a-radio-group>
          <p
            style="line-height: 16px;  color:#999;font-size: 13px"
            v-if="pencostModel == 'PencostModelTotal'"
          >
            每头猪在总饲喂周期的栏位成本
          </p>
          <p style="line-height: 16px;  color:#999;font-size: 13px" v-else>
            平均每天每头猪的栏位成本
          </p>
        </a-form-item>
        <a-form-item
          label="总栏位成本"
          v-if="pencostModel == 'PencostModelTotal'"
        >
          <a-input-number
            class="inputClass"
            style="width: calc(100% - 60px)"
            placeholder="请输入"
            v-decorator="[
              'totalPencost',
              { rules: [{ required: true, message: '请输入总栏位成本' }] },
            ]"
            :min="0"
            :precision="2"
          />
          <span class="unitClass" style="width: 60px">元/头</span>
          <p style="line-height: 16px;  color:#999;font-size: 13px">
          每头猪在总饲喂周期的栏位成本
        </p>
        </a-form-item>
        <a-form-item label="日栏位成本" v-else>
          <a-input-number
            class="inputClass"
            style="width: calc(100% - 60px)"
            placeholder="请输入"
            v-decorator="[
              'pencost',
              { rules: [{ required: true, message: '请输入日栏位成本' }] },
            ]"
            :min="0"
            :precision="2"
          />
          <span class="unitClass" style="width: 60px">元/天/头</span>
          <p style="line-height: 16px;  color:#999;font-size: 13px">
          平均每天每头猪的栏位成本
        </p>
        </a-form-item>
      </template>

      <a-form-item label="其他固定成本" v-if="participate">
        <a-input-number
          class="inputClass"
          placeholder="请输入"
          v-decorator="[
            'otherCost',
            {
              rules: [
                {
                  required: true,
                  message: '包括兽医的耗材成本、现场服务成本、运输成本等',
                },
              ],
            },
          ]"
          :min="0"
          :precision="2"
        />
        <span class="unitClass">元/头</span>
        <p style="line-height: 16px;  color:#999;font-size: 13px">
          包括兽医的耗材成本、现场服务成本、运输成本等
        </p>
      </a-form-item>
      <a-form-item label="优化经济效益" v-if="participate">
        <a-radio-group
          v-decorator="[
            'ecoOpt',
            { rules: [{ required: true, message: '请选择' }] },
          ]"
          size="small"
        >
          <a-radio-button :value="true"> 是 </a-radio-button>
          <a-radio-button :value="false"> 否 </a-radio-button>
        </a-radio-group>
        <p style="line-height: 16px;  color:#999;font-size: 13px">
          选择“是”，系统将基于饲喂程序各阶段配方计算最佳经济效益
        </p>
      </a-form-item>
      <a-form-item style="display: none"
        ><a-input v-decorator="['equationId']"
      /></a-form-item>
    </a-form>
  </div>
</template>
<script>
import { mapState } from "vuex";
export default {
  props: ["formData"],
  data() {
    return {
      form: this.$form.createForm(this),
      spaceType: "",
      currentFeedIntakeOption: [],
      participate: false,
      isEdit: true,
      ecoModel: "",
      description: "", //警告提示语
      feedPriceModel: "FEED_END_USER_PRICE", //饲料价格
      pencostModel: "PencostModelTotal", //栏位成本模式
      feedPriceDays: [], //table数据
      columns: [
        {
          title: "阶段",
          dataIndex: "field",
          width: "40%",
          scopedSlots: { customRender: "field" },
        },
        {
          title: "饲料终端价格（元/吨）",
          dataIndex: "price",
          width: "40%",
          scopedSlots: { customRender: "price" },
        },
      ],
    };
  },
  computed: {
    ...mapState("estimate", ["dataDictionary", "weightData"]),
    ...mapState("procedure", ["procedureDetail"]),
  },
  mounted() {
    this.setVal(this.formData);
    if (this.weightData) {
      let { min, max } = this.weightData;
      if (min == 20 && max == 140) {
        this.description = false;
      } else {
        this.description = `当前饲喂程序体重区间为${min}-${max}kg，将导致预估的生产成本偏低、经济效益偏高，
            建议使用20-140kg的饲喂程序预估经济效益，以获得更具参考性的结果`;
      }
    }
    if (this.procedureDetail) {
      let { pigFeedingProgramWeightList } = this.procedureDetail;
      this.feedPriceDays = pigFeedingProgramWeightList.map((el) => {
        let { startWeight, endWeight } = el;
        let obj = { initialBw: startWeight, finalBw: endWeight };
        return obj;
      });
    }
  },
  watch: {
    formData: {
      handler(val) {
        this.setVal(val);
      },
      deep: true,
    },
    weightData: {
      handler(val) {
        if (val) {
          let { min, max } = val;
          if (min == 20 && max == 140) {
            this.description = false;
          } else {
            this.description = `当前饲喂程序体重区间为${min}-${max}kg，将导致预估的生产成本偏低、经济效益偏高，
            建议使用20-140kg的饲喂程序预估经济效益，以获得更具参考性的结果`;
          }
        }
      },
      deep: true,
    },
    procedureDetail: {
      handler() {
        if (this.procedureDetail) {
          let { pigFeedingProgramWeightList } = this.procedureDetail;
          this.feedPriceDays = pigFeedingProgramWeightList.map((el) => {
            let { startWeight, endWeight } = el;
            let obj = { initialBw: startWeight, finalBw: endWeight };
            return obj;
          });
        }
      },
      deep: true,
    },
  },
  methods: {
    changeEcoModel(val, field) {
      this[field] = val;
    },
    setVal(val) {
      let {
        participate,
        ecoModel,
        gfPigPrice,
        pigCost,
        pencost,
        totalPencost,
        otherCost,
        ecoOpt,
        equationId,
        feedPriceModel,
        pencostModel,
      } = val || {};
      this.setEquationId({ economicId: equationId });
      if (!ecoModel) ecoModel = "IOTCL";
      this.ecoModel = ecoModel;
      // 初始化为undefined
      if (!ecoOpt) ecoOpt = false;
      if (participate === undefined) participate = false;
      this.participate = participate;
      if (!feedPriceModel) feedPriceModel = "FEED_END_USER_PRICE"; //初始化数据默认选中
      this.feedPriceModel = feedPriceModel;
      if (!pencostModel) pencostModel = "PencostModelTotal";
      this.pencostModel = pencostModel;
      setTimeout(() => {
        this.form.setFieldsValue({
          participate,
          ecoModel,
          gfPigPrice,
          pigCost,
          pencost,
          totalPencost,
          otherCost,
          ecoOpt,
          equationId,
          feedPriceModel,
          pencostModel,
        });
      }, 0);
    },

    changeRadio(e, feild) {
      this[feild] = e; //切换单选按钮数据赋值
      let obj = {};
      obj[feild] = e;
      if (feild === "participate")
        this.setVal(Object.assign({}, this.formData, obj));
    },
    setEquationId(data) {
      let { economicId: equationId } = data || {};
      setTimeout(() => {
        this.form.setFieldsValue({ equationId });
      }, 0);
    },
    checkVal(e, field) {
      if (e.target.value === "0.00") {
        this.form.setFieldsValue({ [field]: null });
      }
    },

    //饲料终端价格修改
    handleChage(record, field) {
      let { price } = record || {};
      record[field] = price;
    },
  },
};
</script>